import {
  faBan,
  faCircleCheck,
  faCircleExclamation,
  faHourglassHalf,
  faLock,
  faPaperPlane,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { Card, ResourceIdentifier, Tag, TaskBar, ValueList } from '.';
import config from '../config';
import { Webhook } from '../types';
import formatDate from '../utilities/format-date';
import './WebhookCard.scss';

type WebhookCardProps = {
  webhook: Webhook;
  admin?: boolean;
  [key: string]: any;
};

export function WebhookCard({
  webhook,
  admin,
  ...props
}: WebhookCardProps): ReactElement {
  return (
    <Card className="webhook-card" {...props}>
      <div className="corner-tags-container bottom">
        <Tag intent="danger" icon={faLock} show={webhook.locked}>
          Over plan limit
        </Tag>
        <Tag
          intent={webhook.disabledReason ? 'danger' : 'warning'}
          icon={faBan}
          show={!webhook.activated}
        >
          {webhook.disabledReason ? 'Disabled (failing)' : 'Inactive'}
        </Tag>
        <Tag
          intent="info"
          icon={faHourglassHalf}
          show={webhook.pendingDeliveries > 0}
        >
          {webhook.pendingDeliveries} waiting
        </Tag>
        <Tag
          intent="success"
          icon={faCircleCheck}
          show={webhook.lastDeliveryStatus === 'succeeded'}
        >
          Last delivery succeeded
        </Tag>
        <Tag
          intent="danger"
          icon={faCircleExclamation}
          show={webhook.lastDeliveryStatus === 'failed'}
        >
          Last delivery failed
        </Tag>
      </div>
      <TaskBar
        left={
          <h2>
            <FontAwesomeIcon icon={faPaperPlane} />
            <Link to={`/webhooks/${webhook.id}`}>{webhook.url}</Link>
          </h2>
        }
      />
      <ValueList
        values={{
          Id: <code>{webhook.id}</code>,
          Description: webhook.description || undefined,
          Events: webhook.events.map(event => (
            <Tag key={event} show>
              {event}
            </Tag>
          )),
          Lists:
            webhook.listIds.length === 0
              ? 'All lists'
              : `${webhook.listIds.length} ${
                  webhook.listIds.length === 1 ? 'list' : 'lists'
                }`,
          'Created by': admin ? (
            <ResourceIdentifier
              resourceType="user"
              resource={{
                id: webhook.user?.id ?? '',
                displayName: webhook.user?.displayName ?? '',
              }}
              copyable
            />
          ) : undefined,
          'Created at': formatDate(webhook.createdAt, config.pageDateFormat),
        }}
      />
    </Card>
  );
}
